import("../../../assets/js/splide.js")
	.then(({ Splide }) => {
		const blocks = document.querySelectorAll(".content-gallery-carousel-with-thumbnails")

		blocks.forEach((block) => {
			const mainEl  = block.querySelector(".splide:not(.splide-thumbnails)")
			const thumbEl = block.querySelector(".splide-thumbnails")

			if (!mainEl) return

			const main = new Splide(mainEl, {
				accessibility: true,
				keyboard: "focused",
				type: "fade",
				rewind: true,
				arrows: true,
				pagination: false,
				perPage: 1,
				reducedMotion: {
					speed: 0,
					rewindSpeed: 0,
				},
			})

			if (thumbEl) {
				const thumbnails = new Splide(thumbEl, {
					isNavigation: true,
					fixedWidth: "5rem",
					gap: "0.5rem",
					rewind: true,
					pagination: false,
					arrows: false,
					drag: true,
					reducedMotion: {
						speed: 0,
						rewindSpeed: 0,
					},
				})

				main.sync(thumbnails)
				main.mount()
				thumbnails.mount()

				// Remove non-standard aria-roledescription from thumbnail nav
				thumbEl.removeAttribute("aria-roledescription")

				// Prevent double-announcements — main slider track already handles this
				const thumbTrack = thumbEl.querySelector(".splide__track")
				thumbTrack?.removeAttribute("aria-live")
				thumbTrack?.removeAttribute("aria-atomic")
			} else {
				main.mount()
			}

			// Remove non-standard aria-roledescription from region (role="region" is sufficient)
			mainEl.removeAttribute("aria-roledescription")

			// Remove aria-live + orphaned aria-atomic from track since our counter handles announcements
			const track = mainEl.querySelector(".splide__track")
			track?.removeAttribute("aria-live")
			track?.removeAttribute("aria-atomic")
		})
	})
	.catch((err) => {
		console.error(err)
	})

// Cursor-following arrows
const galleryBlocks = document.querySelectorAll(".content-gallery-carousel-with-thumbnails")

galleryBlocks.forEach((block) => {
	const leftArrow = block.querySelector(".cursor-left-arrow")
	const rightArrow = block.querySelector(".cursor-right-arrow")
	const prevBtn = block.querySelector(".splide__arrow--prev")
	const nextBtn = block.querySelector(".splide__arrow--next")

	if (!leftArrow || !rightArrow) return

	block.addEventListener("mousemove", (e) => {
		const x = e.clientX
		const y = e.clientY
		leftArrow.style.transform = `translate(calc(${x}px - 50%), calc(${y}px - 50%))`
		rightArrow.style.transform = `translate(calc(${x}px - 50%), calc(${y}px - 50%))`
	})

	block.addEventListener("mouseleave", () => {
		leftArrow.style.opacity = "0"
		rightArrow.style.opacity = "0"
	})

	prevBtn?.addEventListener("mouseenter", () => {
		leftArrow.style.opacity = "1"
	})
	prevBtn?.addEventListener("mouseleave", () => {
		leftArrow.style.opacity = "0"
	})

	nextBtn?.addEventListener("mouseenter", () => {
		rightArrow.style.opacity = "1"
	})
	nextBtn?.addEventListener("mouseleave", () => {
		rightArrow.style.opacity = "0"
	})
})